import { ENV } from './config';
import { isAccessibility, isAndroid, isFirefox, isSafari, isTouchDevice } from './utils/is';

// Dynamic imports for development mode only
let gridHelper;
(async () => {
    // if (ENV.IS_DEV) {
    const gridHelperModule = await import('./utils/grid-helper');
    gridHelper = gridHelperModule?.gridHelper;
    // }

    if (ENV.HAS_HIGH_CONTRAST) {
        localStorage.setItem('a11y', 'light');
        document.documentElement.dataset.theme = 'light';
    }
})();

export default function () {
    /**
     * Add grid helper
     */
    gridHelper?.();

    // isFirefox();
    // isSafari();
    // isAndroid();
    isAccessibility();    
    isTouchDevice();
}